import React, { Suspense } from "react";
import LazyLoading from "../layout/LazyLoading";

const ManageSharePointProcessedFiles = React.lazy(() =>
  import(/* webpackChunkName: "ManageSharePointProcessedFiles" */ "./ManageSharePointProcessedFiles")
);

const ManageSharePointProcessedFilesLazy = () => (
  <Suspense fallback={<LazyLoading />}>
    <ManageSharePointProcessedFiles />
  </Suspense>
);

export default ManageSharePointProcessedFilesLazy;
